import React from 'react';
import WidgetComponent from './enqelt-react-widget/widget-example';
import NoIndexMeta from './NoIndexMeta'; // Import NoIndexMeta

function App() {
  return (
    <div style={{ position: 'relative', zIndex: 9999 }}>
      <NoIndexMeta />
      <WidgetComponent />
    </div>
  );
}

export default App;